import { render } from "./streamalerts.vue?vue&type=template&id=74b3b527&scoped=true&ts=true"
import script from "./streamalerts.vue?vue&type=script&lang=ts"
export * from "./streamalerts.vue?vue&type=script&lang=ts"

import "./streamalerts.vue?vue&type=style&index=0&id=74b3b527&scoped=true&lang=css"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b3b527"]])

export default __exports__